/* ════════════════════════════════════════════════════════════
   FORMAT HELPERS  (ES5-safe)
   Extracted from index.jsx — Tier 1 split
   ──────────────────────────────────────────────────────────── */

export function fmt(n) {
  return (n == null || n === "") ? "" : Number(n).toLocaleString(undefined, {maximumFractionDigits:0});
}

export function fmtPrice(n) {
  return (n == null || n === "") ? "" : Number(n).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
}

export function fmtVal(m, n) {
  /* FOC %: one-decimal percentage (derived measure — fu/gu×100) */
  if (m === "fp") return (n == null || n === "") ? "" : Number(n).toFixed(1) + "%";
  /* Coverage %: one-decimal percentage (derived — nph ÷ panel denominator ×100) */
  if (m === "cv") return (n == null || n === "") ? "" : Number(n).toFixed(1) + "%";
  /* Sell-Through %: sell-out ÷ sell-in (derived per base period; Sell-In bands show a dash) */
  if (m === "sth") return (n == null || n === "" || isNaN(n)) ? "\u2014" : Number(n).toFixed(1) + "%";
  /* Profit / Sell-In Value: whole-number currency; blank when the view lacks the columns */
  if (m === "pf" || m === "sv") return (n == null || n === "" || isNaN(n)) ? "" : Number(n).toLocaleString(undefined, {maximumFractionDigits:0});
  /* pli/pdi: GPD UNIT PRICE IU (averaged *_ui price columns) — 2-decimal like all prices */
  return (m === "pl" || m === "pd" || m === "npl" || m === "npd" || m === "pli" || m === "pdi") ? fmtPrice(n) : fmt(n);
}
